import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const ContainerDiv = styled.div<{
    top: number;
    left: number;
    items: number;
}>`
    position: absolute;
    top: ${props => props.top}px;
    left: ${props => props.left}px;
    width: 140px;
    height: ${props =>
        props.items === 3 ? "145px" : props.items === 2 ? "110px" : "75px"};
    padding: 8px;
    background: var(--color-background-surface);
    border-radius: 4px;
    border: 1px var(--formant-highlights-blue) solid;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 1000;
`;

const LabelWrapperDiv = styled.div`
    align-self: stretch;
    height: 32px;
    padding-left: 6px;
    margin-bottom: 10px;
    padding-right: 8px;
    border-radius: 4px;
    justify-content: flex-start;
    align-items: center;
    display: inline-flex;
`;

const ConnectionDiv = styled.div`
    color: var(--formant-silver);
    font-size: 10px;
    font-family: Moderat;
    font-weight: 900;
    text-transform: uppercase;
    line-height: 18px;
    letter-spacing: 1.1px;
    word-wrap: break-word;
`;

const ItemDiv = styled.div<{ isHovered: boolean }>`
    margin-bottom: 8px;
    padding: 4px 8px;
    color: ${props => (props.isHovered ? "white" : "var(--formant-silver)")};
    background: ${props =>
        props.isHovered ? "var(--formant-primary-module)" : "transparent"};
    font-size: 13px;
    font-family: Moderat;
    width: 100%;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    border-radius: 4px;
    cursor: pointer;
    transition:
        background 0.2s ease,
        color 0.2s ease;
`;

export const AddConnectionModal = ({
    position,
    onClose,
    enableHardware,
    enableROS,
    onRosClicked,
    onAPIClicked,
    onHardwareClicked,
}: {
    position: { top: number; left: number };
    onClose: () => void;
    onRosClicked: () => void;
    enableHardware: boolean;
    enableROS: boolean;
    onAPIClicked: () => void;
    onHardwareClicked: () => void;
}) => {
    const modalRef = useRef<HTMLDivElement>(null);
    const [hoveredItem, setHoveredItem] = useState<string | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                modalRef.current &&
                !modalRef.current.contains(event.target as Node)
            ) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const items = ["API"];
    if (enableROS) {
        items.push("ROS topic");
    }
    if (enableHardware) {
        items.push("Hardware");
    }

    return (
        <ContainerDiv
            ref={modalRef}
            top={position.top}
            left={position.left}
            items={items.length}
        >
            <LabelWrapperDiv>
                <ConnectionDiv>Connection</ConnectionDiv>
            </LabelWrapperDiv>
            {items.map(item => (
                <ItemDiv
                    key={item}
                    isHovered={hoveredItem === item}
                    onMouseEnter={() => setHoveredItem(item)}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={() => {
                        if (item === "ROS topic") {
                            onRosClicked();
                        } else if (item === "API") {
                            onAPIClicked();
                        } else if (item === "Hardware") {
                            onHardwareClicked();
                        }
                        onClose();
                    }}
                >
                    {item}
                </ItemDiv>
            ))}
        </ContainerDiv>
    );
};
